import {applyMiddleware, createStore} from "redux";
import logger from 'redux-logger'
import thunkMiddleware from 'redux-thunk';
import rootReducer from "../reducers";
import {composeWithDevTools} from "redux-devtools-extension";

const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(thunkMiddleware, logger)));

export default store;
